"use client"

import styled, { css } from "styled-components"

import { Button as BaseButton } from "../Button"

export const Button = styled(BaseButton)`
  ${({ theme }) => {
    const { colors, fonts, spaces } = theme
    const { content } = colors
    return css`
      justify-content: space-between;
      padding: ${spaces.small} ${spaces.large};
      background-color: ${content.bg};
      line-height: ${fonts.lineHeight.double};
    `
  }}
`

export const ButtonTextTagContainer = styled.div`
  ${({ theme }) => {
    const { fonts, spaces } = theme
    const { size, weight } = fonts
    return css`
      display: flex;
      align-items: center;
      gap: ${spaces.extraSmall};
      font-size: ${size.paragraph};
      font-weight: ${weight.regular};
    `
  }}
`
